import { Injectable } from '@angular/core';
import { SignInMobileRequest } from '../../../libs/proto/mobile_pb';
import { BinaryWriter } from 'google-protobuf';

@Injectable({
  providedIn: 'root'
})
export class SigninReqConversionService {

  constructor() { }

  ToStorage(req: SignInMobileRequest) {
    const w = new BinaryWriter();
    SignInMobileRequest.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (signinRequest: SignInMobileRequest, errorConvert: any) => void) {
    try {
      callback( SignInMobileRequest.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }
}
